<template>
    <div id="app" :class="{'page-loading': isLoading}">
        <Navbar v-if="!isLoading" />
        <main class="main-content">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </main>
        <Footer v-if="!isLoading" />
        
        <!-- WhatsApp Popup - Solo se muestra si wa_popup_active = true Y hay agentes -->
        <WhatsAppPopup v-if="shouldShowWhatsAppPopup" />
        
        <ScrollToTop />
    </div>
</template>

<script>
import Navbar from './components/layout/Navbar.vue';
import Footer from './components/layout/Footer.vue';
import WhatsAppPopup from './components/common/WhatsAppPopup.vue';
import ScrollToTop from './components/common/ScrollToTop.vue';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    name: 'App',
    components: {
        Navbar,
        Footer,
        WhatsAppPopup,
        ScrollToTop
    },
    computed: {
        ...mapState(['config', 'isLoading']),
        ...mapGetters(['whatsappAgents']),
        
        /**
         * WhatsApp popup solo se muestra si:
         * 1. No está cargando
         * 2. config.wa_popup_active === true
         * 3. Hay al menos 1 agente activo
         */
        shouldShowWhatsAppPopup() {
            console.log('WhatsApp Popup Check:', {
                isLoading: this.isLoading,
                config: this.config,
                wa_popup_active: this.config?.wa_popup_active,
                agents: this.whatsappAgents,
                agentsCount: this.whatsappAgents?.length
            });

            return !this.isLoading && 
                   this.config && 
                   this.config.wa_popup_active === true && 
                   this.whatsappAgents && 
                   this.whatsappAgents.length > 0;
        }
    },
    created() {
        this.loadInitialData();
    },
    methods: {
        ...mapActions(['loadConfig', 'loadCategories', 'loadPartners', 'loadWhatsappAgents']),
        async loadInitialData() {
            try {
                await Promise.all([
                    this.loadConfig(),
                    this.loadCategories(),
                    this.loadPartners(),
                    this.loadWhatsappAgents()
                ]);
            } catch (error) {
                console.error('Error loading initial data:', error);
            }
        }
    }
}
</script>

<style>
/* ESTILOS GLOBALES - SIN SCOPED */

:root {
    --primary-dark: #0a1628;
    --primary-blue: #1e3a5f;
    --accent-gold: #d4af37;
    --accent-teal: #2dd4bf;
    --text-light: #f8fafc;
    --text-gray: #94a3b8;
    --background: #0f172a;
    --card-bg: #1e293b;
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
}

body {
    font-family: 'Outfit', sans-serif;
    background-color: var(--background);
    color: var(--text-light);
    overflow-x: hidden;
    line-height: 1.6;
}

h1, h2, h3, h4, h5, h6 {
    font-family: 'Playfair Display', serif;
    color: var(--text-light);
}

#app {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: var(--background);
    width: 100%;
    overflow-x: hidden;
}

.main-content {
    flex: 1;
    width: 100%;
    overflow-x: hidden;
}

.page-loading {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--background);
}

.page-loading::before {
    content: '';
    width: 50px;
    height: 50px;
    border: 5px solid rgba(212, 175, 55, 0.1);
    border-top-color: var(--accent-gold);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}

a {
    text-decoration: none;
    color: inherit;
}

::-webkit-scrollbar {
    width: 10px;
}

::-webkit-scrollbar-track {
    background: var(--primary-dark);
}

::-webkit-scrollbar-thumb {
    background: var(--accent-gold);
    border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--accent-teal);
}
</style>